module.exports = __webpack_public_path__ + "img/2.d27f022b.png";